import React from 'react';
import ComingSoon from '../../../components/ui/ComingSoon/ComingSoon';

const EventParticipantMailingPage: React.FC = () => {
  return <ComingSoon />;
};

export default EventParticipantMailingPage;

